import React, { useContext, useRef, useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import { themeContext } from "../../Context";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const form = useRef();
  const [done, setDone] = useState(false)
  const sendEmail = (e) => {
   
    e.preventDefault();
    if (!form.current.checkValidity()) {
      toast.error('Please fill out all the required fields.');
      return;
    }
    
    emailjs
      .sendForm(
        "service_3fq9wpc",
        "template_llz7t0r",
        form.current,
        "ykUf7ef3G80UFxJZD"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success('Thanks for contacting me! Your message has been sent.');
          setDone(true);
          form.current.reset()
        },
        (error) => {
          console.log(error.text);
          toast.error('An error occurred while sending the message. Please try again.');

        }
      );
  };

  return (
    <div className="contact-form" id="contact">
      {/* left side copy and paste from work section */}
      <div className="w-left">
        <div className="awesome">
          {/* darkMode */}
          <span style={{color: darkMode?'white': ''}}>Get in Touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>
      </div>
      {/* right side form */}
      <div className="c-right">
        <form ref={form} onSubmit={sendEmail} noValidate>
          <input type="text" name="user_name" className="user"  placeholder="Name" required/>
          <input type="email" name="user_email" className="user" placeholder="Email" required/>
          <textarea name="message" className="user" placeholder="Message" required/>
          <input type="submit" value="Send" className="button"/>
          <span>{done && "Thanks for Contacting me"}</span>
          <div
            className="blur c-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
      <ToastContainer />

    </div>
    
  );
};

export default Contact;
